import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BranchesModel } from 'common/models/page-models/Branches/branches-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { BranchesFormWidgetService } from 'common/widget/branches/branches-form-widget.service';



@Injectable({
    providedIn: 'root'
})
export class BranchesFormResolver extends FormResolverService<BranchesModel> {
    constructor(
        protected fs: BranchesFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);

    }
}
